import React from 'react';
// import d3 from 'd3';

import Linechart from '../lineChart/Linechart.component';

import {timeParse,timeFormat} from 'd3-time-format';
import {scaleLinear, scaleOrdinal, scaleTime} from 'd3-scale';
import {line} from 'd3-shape';
import {extent, max, mean, median} from 'd3-array';
import {select as d3select} from 'd3-selection';
import {axisBottom as d3axisBottom, axisLeft as d3axisLeft} from 'd3-axis';
import {formatDefaultLocale,format} from 'd3-format';
import {interpolate} from 'd3-interpolate';
import {keys, nest} from 'd3-collection';

const dataSource= require('json!../smallMultiples/data/data.json');

/************************************************************************/

class SmallMultiples extends React.Component {

  basic = [];
  married = [];

  constructor(props) {
    super(props);

    this.changeData = this.changeData.bind(this);

    const dataByCircle = nest()
      .key(function (d) {
        return d.KreisSort
      })
      .key(function (d) {
        return d.SteuerTariflang
      })
      .entries(dataSource);

    for(var i=0; i<dataByCircle.length; i++) {
      this.basic.push([])
      for(var ii=0; ii<dataByCircle[i]['values'][0]['values'].length; ii++) {
        this.basic[i].push({
          title: dataByCircle[i]['values'][0]['values'][ii]['KreisSort'],
          count: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['armindex'])),
          absolute: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['eink_arm_Sum'])),
          percentage: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['ant_eink_arm'])),
          day: '01-01-'+dataByCircle[i]['values'][0]['values'][ii]['SteuerJahr']
        })

      }
    }

    for(var m=0; m<dataByCircle.length; m++) {
      this.married.push([])
      for(var mm=0; mm<dataByCircle[m]['values'][1]['values'].length; mm++) {
        this.married[m].push({
          title: dataByCircle[m]['values'][1]['values'][mm]['KreisSort'],
          count: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['armindex'])),
          absolute: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['eink_arm_Sum'])),
          percentage: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['ant_eink_arm'])),
          day: '01-01-'+dataByCircle[m]['values'][1]['values'][mm]['SteuerJahr']
        })

      }
    }

    /* Set data states */

    this.state = {
      actualDataSource: this.basic,
      actualMin: 80,
      actualMax: 130,
      activeButton: 'basic'
    };
  }

  changeData(e) {
    let newDataSource = e.currentTarget.getAttribute('data-selector');
    console.log(newDataSource);
    console.log(newDataSource);
    if(newDataSource == 'basic') {
      this.setState({
        actualDataSource: this.basic,
        activeButton: 'basic',
        actualMin: 70,
        actualMax: 180
      })
    } else {
      this.setState({
        actualDataSource: this.married,
        activeButton: 'married',
        actualMin: 70,
        actualMax: 180
      })
    }
    console.log(this.state.actualDataSource)
  }


  render() {

    const linechartData = [0,1,2,3,4,5,6,7,8,9,10];

    let appendSmallLineCharts = (v,i) => {
      // console.log(v)
      return(
        <Linechart
          key={`linechart-${i}`}
          chartTitle={`Kreis ${i+1}`}
          width={
            this.props.width > 500 ? 160 : this.props.width - 60
          }
          height={130}
          chartClassName='small'
          chartId={`linechart-${i}`}
          readerIsCityCitizen={this.props.readerIsCityCitizen}
          readerMadeHisChoice={this.props.readerMadeHisChoice}
          circleRadius={3}
          circleFill='#E23C4E'
          circleStroke={0}
          circleStrokeFill='#ffffff'
          tickFormatX='%y'
          tickFormatY=',.0f'
          ticksX={5}
          ticksY={5}
          minY={this.state.actualMin}
          maxY={this.state.actualMax}
          tooltipWidth={70}
          tooltipHeight={55}
          tooltipFontSize={12}
          linechartClass='small'
          dataSource={this.state.actualDataSource[i]}
        />
      )
    }


    return(

      <div
        className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded linechart`}
      >

        <div
          className='ui inverted simple dimmer'
          style={{
            display: this.state.readerMadeHisChoice ? 'none' : 'block'
          }}
        >
        </div>


      <div style={{maxWidth: '640px', margin: '0 auto', marginTop: '30px'}}>
        <h3
          style={{
            marginBottom: '0px',
            fontFamily: 'Benton Sans Cond',
            fontWeight: 'bold'
          }}
        >
          Entwicklung der relativen Armut nach Stadtkreisen
        </h3>
        <p>
          Die Linien zeigen die Veränderung der relativen Armut seit 1999. Fahren Sie mit dem Cursor über die roten Punkte, um zu sehen, wie viele Menschen weniger als 50% des mittleren Einkommens versteuern.
        </p>

        <div
          className='button-wrapper'
          style={{textAlign: 'center'}}
        >
          <div className='ui small buttons'>
            <button
              className={`ui button ${this.state.activeButton == 'basic' ? 'active' : ''}`}
              data-selector='basic'
              onClick={this.changeData}
            >
              Ledige
            </button>
            <div
              className=''
            ></div>
            <button
              className={`ui button ${this.state.activeButton == 'married' ? 'active' : ''}`}
              data-selector='married'
              onClick={this.changeData}
            >
              Verheiratete
            </button>
          </div>
        </div>


        <div className='linechart-wrapper small'>
          {
            this.state.actualDataSource.map(appendSmallLineCharts)
          }
        </div>

        <p
          className='graphic legend'
        >Das City-Quartier im Stadtkreis 1 ist ein Spezialfall, weil dort auch Obdachlose und Personen zugerechnet werden, die ausserhalb der Stadt in einem Gefängnis oder Heim sind.</p>

      </div>

      </div>
    )

  }

}

SmallMultiples.propTypes = {

  readerMadeHisChoice: React.PropTypes.bool,
  readerIsCityCitizen: React.PropTypes.bool,
  width: React.PropTypes.number,
  height: React.PropTypes.number
}

export default SmallMultiples;









// WEBPACK FOOTER //
// ./src/components/smallMultiples/SmallMultiples.js